import styled from 'styled-components';

export const ArchivedSection = styled.div`
    padding: 20px;
`;

export const ArchivedCard = styled.div`
    padding: 12px;
    background: #22272B;
    border-radius: 3px;
    margin-bottom: 8px;
    cursor: pointer;
    
    &:hover {
        background: #2C333A;
    }
`;

export const CardTitle = styled.div`
    color: #B6C2CF;
    font-size: 14px;
    margin-bottom: 4px;
`;

export const CardMeta = styled.div`
    color: #8C9BAB;
    font-size: 12px;
`;

export const SectionTitle = styled.h3`
    color: #B6C2CF;
    margin-bottom: 16px;
`;

export const EmptyMessage = styled.div`
    color: #8C9BAB;
`;